"use strict";

// import '@babel/polyfill';

import $ from 'jquery';

// import LazyLoad from 'vanilla-lazyload';

// SimpleShare
import SimpleShare from './plugins/simpleshare/index';

// AOS
import AOS from 'aos';
import 'aos/dist/aos.css';

import { layer } from './plugins/layer/index';

import '@splidejs/splide/css';
import Splide from '@splidejs/splide';
// import { Grid } from '@splidejs/splide-extension-grid';

// import imagesLoaded from 'imagesloaded';
// import jQueryBridget from 'jquery-bridget';
// import Masonry from 'masonry-layout';
// jQueryBridget('masonry', Masonry, $);

import validate from 'jquery-validation';
import axios from 'axios';


import 'select2/dist/css/select2.min.css';
import select2 from 'select2';

// gsap
// import {gsap} from 'gsap';
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// gsap.registerPlugin(ScrollTrigger);

// import * as CookieConsent from 'vanilla-cookieconsent';
// import 'vanilla-cookieconsent/dist/cookieconsent.css';

// Lenis

// import 'waypoints/lib/noframework.waypoints';

import { CountUp } from 'countup.js';

import Lenis from 'lenis';

// import 'altcha';

import './iconfont/iconfont';

import Language from './language';
const lang = new Language();

window.$ = $;

$.validator.addMethod("isMobile", function(value, element) {  
    var length = value.length;  
    var mobile = /^(1[0-9][0-9]{9})|(18[0-9]{9})|(14[0-9]{9})|(17[0-9]{9})|(15[0-9]{9})$/;  
    return this.optional(element) || (length == 11 && mobile.test(value));  
}, lang.phoneErr); 
$.validator.addMethod("valueNotEquals", function(value, element, arg){
	return arg !== value;
}, lang.selectAnItem);
$.extend($.validator.messages, {
	required: lang.required,
	email: lang.emailErr
});


(() => {

	// 测试用
	// const domLoop = document.querySelectorAll('[data-loop]');
	// if (domLoop) {
	// 	domLoop.forEach(item => {
	// 		const len = item.getAttribute('data-loop');
	// 		const sourceItem = item.innerHTML;
	// 		for (let i = 0; i < len; i++) {
	// 			// console.log(item.innerHTML);
	// 			// item.appendChild(item.innerHTML);
	// 			item.innerHTML += sourceItem
	// 		}
	// 	});
	// }
	
	const $body = document.body;
	window.lenis = new Lenis();

	window.lenis.on('scroll', ({ animatedScroll, limit, velocity, direction, progress }) => {
		// console.log(animatedScroll);
		animatedScroll > 100 ? $body.classList.add('fixed-menu') : $body.classList.remove('fixed-menu')
		direction > 0 ? $body.classList.add('drop-menu') : $body.classList.remove('drop-menu')
	});

	function raf(time) {
		window.lenis.raf(time);
		requestAnimationFrame(raf);
	}

	requestAnimationFrame(raf);

	const scrollEvent = new Event('scroll');
	// 触发 window 上的 scroll 事件
	window.dispatchEvent(scrollEvent);

})();

// Header
(() => {

	const hsInput = document.querySelector('.js-hs-input');
	const hsBox = document.querySelector('.header-search');
	hsInput.addEventListener('focus', () => {
		hsBox.classList.add('active');
	});
	hsInput.addEventListener('blur', () => {
		hsBox.classList.remove('active');
	});


	document.querySelector('.js-btn-menu').addEventListener('click', function(){
		document.body.classList.toggle('menu-open');
	});

	$('.hm-link.has-sub').on('click', function(e) {
		if (window.innerWidth < 1025) {
			e.preventDefault();
			const box = $(this).parents('.hm-li');
			const subMenu = box.find('.hm-sub');
			if (box.hasClass('open')) {
				box.removeClass('open');
				subMenu.slideUp('fast');
			} else {
				box.addClass('open');
				subMenu.slideDown('fast');
			}
		}
	})

})();

// About Us
(() => {
	if (document.querySelector('.js-splide-history')) {
		const splideHistory = new Splide('.js-splide-history', {

		}).mount();
		
		document.querySelector('.js-history-prev').addEventListener('click', () => {
			splideHistory.go('<');
		}, false);
		document.querySelector('.js-history-next').addEventListener('click', () => {
			splideHistory.go('>');
		}, false);
	}

	if (document.querySelector('.js-splide-team')) {
		const splideTeam = new Splide('.js-splide-team', {
			gap: '1.6667vw',
			breakpoints: {
				1024: {
					gap: 20
				}
			}
		}).mount();
		
		document.querySelector('.js-team-prev').addEventListener('click', () => {
			splideTeam.go('<');
		}, false);
		document.querySelector('.js-team-next').addEventListener('click', () => {
			splideTeam.go('>');
		}, false);
	}

	$('.faq-item__header').on('click', function(){

		const i = $(this).parents('.faq-item').index();

		$('.faq-item').each(function(index, item){
			const body = $(item).find('.faq-item__body');
			if (i === index) {
				if ($(item).hasClass('active')) {
					$(item).removeClass('active');
					body.slideUp(300);
				} else {
					$(item).addClass('active');
					body.slideDown(300);
				}
			} else {
				if ($(item).hasClass('active')) {
					$(item).removeClass('active');
					body.slideUp(300);
				}
			}
		});

		$('.faq-item').eq(0).trigger('click');
		
	});

	$('.js-view-all').on('click', function() {
		$(this).parents('.list-box').toggleClass('show');
	});


	if (document.querySelector('.js-splide-busib')) {
		const splideBusib = new Splide('.js-splide-busib', {
			gap: '1.5625vw',
			breakpoints: {
				1024: {
					gap: 20
				}
			}
		}).mount();

		document.querySelector('.js-busib-prev').addEventListener('click', () => {
			splideBusib.go('<');
		}, false);
		document.querySelector('.js-busib-next').addEventListener('click', () => {
			splideBusib.go('>');
		}, false);

		const langCode = document.documentElement.getAttribute('lang');
		$('.js-select2').on('select2:close', function(e){
			// console.log(e.params.data);
			const name = $(this).attr('name');

			console.log(name);
			
			const bitmain = $('.js-select2-bitmain').val();
			const whatsminer = $('.js-select2-whatsminer').val();
			let url = '/business/crypto-miners';
			if (langCode == 'HK') {
				url = '/hk/business/crypto-miners'
			}
			console.log(langCode);

			// if (bitmain) {
			// 	if (bitmain != 1) {
			// 		url += `?bitmain=${bitmain}`;
			// 		if (whatsminer != 1) {
			// 			url += `&whatsminer=${whatsminer}`
			// 		}
			// 	} else {
			// 		if (whatsminer != 1) {
			// 			url += `?whatsminer=${whatsminer}`
			// 		}
			// 	}
			// }
			// console.log('btmain:', bitmain, 'whatsminer:', whatsminer)
			if (name == 'bitmain') {
				url += `?bitmain=${bitmain}`;
			} else if (name == 'whatsminer') {
				url += `?whatsminer=${whatsminer}`;
			}



			console.log(url);
			axios.get(url).then((res) => {
				// console.log(res.data);
				// console.log();
				// const str = $(res.data).find('.splide__list').html();
				// console.log();

				const splideLen = splideBusib.length;
				if (splideLen > 0) {
					// console.log('length' + splideLen);
					const arr = [];
					for(let i = 0; i < splideLen; i++) {
						arr.push(i)
					}
					splideBusib.remove(arr);
					$('.js-busib-pager').removeClass('opacity-0');
				} else {
					$('.js-busib-pager').addClass('opacity-0');
				}

				const liArr = $(res.data).find('.splide__slide');
				// console.log('length:', liArr.length );
				for (let i = 0; i < liArr.length; i++) {
					// console.log($(liArr[i]).html());
					splideBusib.add(`<li class="splide__slide">${$(liArr[i]).html()}</li>`);
				}

				// console.log($(str).find('li').length);
				// for (let i = 0; i < str.length; i++) {
				// 	console.log(str[i].html());
				// }
				
				// const eArr = JSON.parse(str);
				
				// calcMap(eArr);

				AOS.refresh();

			})
		});

	}


	// console.log('text');
	if (document.querySelector('.js-chart-box')) {
		import('./page/highcharts').then((res) => {
			res.default();
		});
	}

})();

// Index
(() => {
	if (document.querySelector('.js-splide-ib')) {

		const splideIb = new Splide('.js-splide-ib', {
			classes: {
				pagination: 'ib-pager',
				page: 'ib-dot'
			}
		}).mount();

		const { Elements, Autoplay } = splideIb.Components;

		splideIb.on('move', function(newIndex){
			// $('.ib-tab > span').removeClass('current').eq(newIndex).addClass('current');
			// console.log(Slide);
			// console.log(newIndex, 'current');
			Elements.slides.forEach(function(item, index){
				// console.log(index);

				const videoItem = Elements.slides[index].getElementsByTagName('video')[0];
				
				if (videoItem) {
					if (index === newIndex) {
						videoItem.currentTime = 0;
						videoItem.play();
						// Elements.pause();
						Autoplay.pause();
						// console.log('pause', index, 'video');
					}
				}
				
			});
		});

		$('.js-ib-video').on('ended', function(){
			Autoplay.play();
		});


		if (document.querySelector('.js-ib-video')) {

			const changePoster = () => {
				$('.js-ib-video').each((index, item) => {
					console.log(index);
					const poster_pc = $(item).data('poster-pc');
					const poster_m = $(item).data('poster-m');
		
					const poster = window.innerWidth > 750 ? $(item).data('poster-pc') : $(item).data('poster-m');
					const video = window.innerWidth > 750 ? $(item).data('video-pc') : $(item).data('video-m');
		
					console.log(poster, video);
		
					$(item).attr('poster', poster);
					$(item).attr('src', video);
				});
			}
			
			$(window).on('resize', ()=> {
				changePoster();
			}).trigger('resize');
		}

		const splideIbt = new Splide('.js-splide-ibt', {
			height: '18vw',
			breakpoints: {
				768: {
					height: '144px'
				}
			}
		}).mount();
		splideIbt.go(1);

	}

	if (document.querySelector('.js-animnum-box')) {
		const nums = document.querySelectorAll('.js-animnum');
		nums.forEach((item, index) => {
			const id = item.getAttribute('id');
			const num = item.innerText;
			// console.log(num.length);
			const sval = Math.pow(10, num.length - 1);
			const countUp = new CountUp(id, num, { enableScrollSpy: true, duration: 2, separator: '', startVal: sval, scrollSpyOnce: true, easingFn: function (t, b, c, d) {
				var ts = (t /= d) * t;
				var tc = ts * t;
				return b + c * (tc * ts + -5 * ts * ts + 10 * tc + -10 * ts + 5 * t);
			}});
		});
    }

	if (document.querySelector('.js-splide-ca')) {
		const splideIca = new Splide('.js-splide-ca', {
			height: '11.875vw',
			breakpoints: {
				768: {
					height: '72px'
				}
			}
		}).mount();
		const splideIcb = new Splide('.js-splide-cb', {
			height: '3.75vw',
			breakpoints: {
				768: {
					height: '48px'
				}
			}
		}).mount();
		splideIca.sync(splideIcb);
	}

	if (document.querySelector('.js-splide-indexg')) {
		const splideIg = new Splide('.js-splide-indexg', {

		}).mount();
		const { Autoplay } = splideIg.Components;
		
		const box = document.querySelector('.js-index-g');
		const igItems = document.querySelectorAll('.indexg-item');

		box.addEventListener('mouseenter', () => {
			Autoplay.pause();
		}, false);
		box.addEventListener('mouseleave', () => {
			Autoplay.play();
		}, false);

		igItems[0].classList.add('current');
		splideIg.on('move', (index, prev, dest) => {
			igItems.forEach((item, i) => {
				if (index === i) {
					item.classList.add('current')
				} else {
					item.classList.remove('current')
				}
			});
		});
		igItems.forEach((item, i) => {
			item.addEventListener('mouseenter',() => {
				splideIg.go(i);
			})
		});
	}

	if (document.querySelector('.js-splide-busia')) {
		var elms = document.getElementsByClassName( 'js-splide-busia' );

		for ( var i = 0; i < elms.length; i++ ) {
			new Splide( elms[ i ] ).mount();
		}
	}
	
})();

// Contact
(() => {
	if (document.getElementById('contactForm')) {
		let isSubmit = true;
		const form = $('#contactForm');
		const btnSubmit = form.find('.fcf-submit');
		form.validate({
			submitHandler: function(form) {
				if (isSubmit) {
					isSubmit = false;
					const postURL = $(form).attr('action');
					const postData = $(form).serialize();

					axios.post(postURL, postData)
					.then(function (res) {
						if (res.data.code == '200') {
							layer.msg(res.data.msg);
							$('#contactForm')[0].reset();
						} else {
							layer.msg(res.data.msg);
						}
						isSubmit = true;
					})
					.catch(function (err) {
						layer.msg(err.data.msg);
						isSubmit = true;
					});
				}
			},
			rules: {
				name: {
					required: true
				},
				email: {
					email: true,
					required: true
				},
				comments: {
					required: true
				}
			}
		})
		btnSubmit.on('click', function(){
			form.submit();
		});
	}
})();

// Select 2
(() => {
	if ($('.js-select2').length) {
		// console.log('ttt');
		$('.js-select2').each(function(index, item){
			const placeholder = $(item).attr('aria-placeholder');
			const isPrefix = $(item).attr('data-prefix');
			$(item).select2({
				placeholder: '',
				minimumResultsForSearch: Infinity,
				dropdownParent: $('#select2Dropdown'),
				templateSelection: function (data) {
					if (data.id === '') { // adjust for custom placeholder values
						return placeholder;
					} else {
						if (isPrefix == "true") {
							return placeholder+data.text;
						} else {
							// return data.text;
							return placeholder;
						}
					}
				}
			});
		})
	}
})();

// INIT
(() => {
	// Lazyload data-src data-bg data-poster
	// var myLazyLoad = new LazyLoad({
	// 	threshold: 800
	// });

	// Social Share
	const share = new SimpleShare({
		url: '',
		title: '',
		content: '',
		pic: ''
	});
	const shareLinks = document.querySelectorAll('[data-share]');
	shareLinks.forEach(link => {
		link.addEventListener('click', () => {
			share.goShare(link.getAttribute('data-share'));
		})
	});

	AOS.init({
		offset: 50,
		duration: 800
	});

})();

// CookieConsent
(() => {
	/**
	 * All config. options available here:
	 * https://cookieconsent.orestbida.com/reference/configuration-reference.html
	*/
	document.documentElement.classList.add('cc--defaultmode');
	
	CookieConsent.run({

		categories: {
			necessary: {
				enabled: true,  // this category is enabled by default
				readOnly: true  // this category cannot be disabled
			},
			required: {
				enabled: true,  // this category is enabled by default
				readOnly: false  // this category cannot be disabled
			},
			analytics: {}
		},

		guiOptions: {
			consentModal: {
				layout: 'bar',
				position: 'bottom',
				flipButtons: false,
				equalWeightButtons: true
			},
			preferencesModal: {
				layout: 'box',
				// position: 'left right',
				flipButtons: false,
				equalWeightButtons: true
			}
		},

		language: {
			default: 'en',

			translations: {
				en: {

					consentModal: {
						title: '',
						description: 'We use our own and third-party cookies to ensure the proper functioning of the web portal and its complements, perform navigation analysis and show multimedia content. If you continue browsing, you accept the use of this technology. For more information please see our Cookies Policy. <a href="/cookie-statement" style="text-decoration:underline;">Learn more</a>',
						acceptAllBtn: 'Accept all',
						acceptNecessaryBtn: 'Reject all',
						showPreferencesBtn: 'Customize'
					},
					preferencesModal: {
						title: 'Manage cookie preferences',
						acceptAllBtn: 'Save settings',
						acceptNecessaryBtn: 'Reject all',
						savePreferencesBtn: 'Accept current selection',
						closeIconLabel: 'Close modal',
						sections: [
							// {
							// 	title: 'Somebody said ... cookies?',
							// 	description: 'I want one!'
							// },
							{
								title: 'Technically required',
								description: 'Required web technologies and cookies make our website technically accessible to and usable for you. This applies to fundamental base functionalities such as navigation on the website, correct display in your internet browser or requesting your consent. Without these web technologies and cookies our website does not work.',

								//this field will generate a toggle linked to the 'required' category
								linkedCategory: 'required'
							},
							{
								title: 'Analysis and statistics',
								description: 'We want to constantly improve the user-friendliness and performance of our websites. For this reason we use analysis technologies (including cookies) which pseudonymously measure and evaluate which functions and content of our websites are used, how and how often. On this basis we can improve our websites for users.',
								linkedCategory: 'analytics'
							}
							// ,
							// {
							// 	title: 'More information',
							// 	description: 'For any queries in relation to my policy on cookies and your choices, please <a href="#contact-page">contact us</a>'
							// }
						]
					}
				}
			}
		}
	});
});